import React from 'react';
import { Datagrid, DeleteButton, List, TextField, DateField } from 'react-admin';
import DuplicateButton from '../../../commonComponents/DuplicateButton';
import CustomListActions from '../../../commonComponents/ListActions/CustomListActions';
import StatusField from '../../../commonComponents/StatusField';
import { duplicateRecord } from '../../../helpers/duplicateQuiz';

const duplicatePersonalityQuiz = (record) => {
  const duplicatedRecord = duplicateRecord(record);

  console.log(record);
  console.log(duplicatedRecord);

  // duplicatedRecord.default_result = record.default_result;
  // duplicatedRecord.records = record.records.map((pattern) => ({
  //   pattern: pattern.pattern,
  //   result: pattern.result,
  // }));

  return duplicatedRecord;
};

const PersonalityQuizzesList = (props) => (
  <List
    title="Personality quizzes"
    exporter={false}
    actions={<CustomListActions />}
    bulkActionButtons={false}
    sort={{ field: 'id', order: 'DESC' }}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="ID" source="id" />
      <TextField label="Name" source="name" sortable={false} />
      <StatusField label="Status" source="status" sortable={false} />
      <DateField label="Publish date" source="published_at" />
      <DuplicateButton copyRecord={duplicatePersonalityQuiz} />
      <DeleteButton undoable={false} />
    </Datagrid>
  </List>
);

export default PersonalityQuizzesList;
